/**
 * @param {string} url
 * @returns {Object}
 */
export function param2Obj1(url) {
  const search = decodeURIComponent(url.split('?')[1]).replace(/\+/g, ' ')
  if (!search) {
    return {}
  }
  const obj = {}
  const searchArr = search.split('&')
  searchArr.forEach(v => {
    const index = v.indexOf('=')
    if (index !== -1) {
      const name = v.substring(0, index)
      const val = v.substring(index + 1, v.length)
      obj[name] = val
    }
  })
  return obj
}

/**
 * This is just a simple version of deep copy
 * Has a lot of edge cases bug
 * If you want to use a perfect deep copy, use lodash's _.cloneDeep
 * @param {Object} source
 * @returns {Object}
 */
export function deepClone1(source) {
  if (!source && typeof source !== 'object') {
    throw new Error('error arguments', 'deepClone')
  }
  const targetObj = source.constructor === Array ? [] : {}
  Object.keys(source).forEach(keys => {
    if (source[keys] && typeof source[keys] === 'object') {
      targetObj[keys] = deepClone1(source[keys])
    } else {
      targetObj[keys] = source[keys]
    }
  })
  return targetObj
}


import Layout from '@/views/layout/Layout'


export const constantRouterMap1 = [{
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [{
      path: '/redirect/:path*',
      component: () => import('@/views/redirect/index')
    }]
  },
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },
  {
    path: '/404',
    component: () => import('@/views/errorPage/404'),
    hidden: true
  },
  {
    path: '/401',
    component: () => import('@/views/errorPage/401'),
    hidden: true
  }
]


export const asyncRouterMap1 = [{
    path: '/guide', //系统管理
    component: Layout,
    redirect: 'noRedirect',
    name: 'guide',
    alwaysShow: true,
    meta: {
      title: 'guide',
      icon: 'lock',
    },
    children: [{
        path: 'user',
        component: () => import('@/views/guide/user'),
        name: 'user',
        meta: {
          title: 'guide1',
          icon: 'form',
          roles: ['admin', ]
        },
        children: [{
            path: 'user/increase',
            meta: {
              title: 'increase'
            }
          },
          {
            path: 'user/delete',
            meta: {
              title: 'delete'
            }
          },
          {
            path: 'user/reset',
            meta: {
              title: 'reset'
            }
          },
          {
            path: 'user/edit',
            meta: {
              title: 'edit'
            }
          },
          {
            path: 'user/query',
            meta: {
              title: 'query'
            }
          },
        ]
      },
      {
        path: 'role1',
        component: () => import('@/views/guide/role1'),
        name: 'role1',
        meta: {
          title: 'guide2',
          icon: 'form',
          roles: ['admin']
        },
        children: [
          {
            path: 'role1/increase',
            meta: {
              title: 'increase'
            }
          },
          {
            path: 'role1/delete',
            meta: {
              title: 'delete'
            }
          },
          {
            path: 'role1/edit',
            meta: {
              title: 'edit'
            }
          },
          {
            path: 'role1/query',
            meta: {
              title: 'query'
            }
          },
        ]
      },
      {
        path: 'regional',
        component: () => import('@/views/guide/regional'),
        name: 'regional',
        meta: {
          title: 'guide3',
          icon: 'form',
          roles: ['admin', 'editor']
        },
        children: [{
            path: 'regional/increase',
            meta: {
              title: 'increase'
            }
          },
          {
            path: 'regional/delete',
            meta: {
              title: 'delete'
            }
          },
          {
            path: 'regional/edit',
            meta: {
              title: 'edit'
            }
          },
          {
            path: 'regional/query',
            meta: {
              title: 'query'
            }
          },
        ]
      },

    ]
  },
  {
    path: '/service', //服务管理
    component: Layout,
    redirect: 'noRedirect',
    name: 'service',
    alwaysShow: true,
    meta: {
      title: 'service',
      icon: 'lock',

    },
    children: [{
        path: 'personnel',
        component: () => import('@/views/service/personnel'),
        name: 'personnel',
        meta: {
          title: 'service1',
          icon: 'form',
          roles: ['admin', 'editor']
        },
        children: [{
            path: 'personnel/increase',
            meta: {
              title: 'increase'
            }
          },
          {
            path: 'personnel/delete',
            meta: {
              title: 'delete'
            }
          },
          {
            path: 'personnel/edit',
            meta: {
              title: 'edit'
            }
          },
          {
            path: 'personnel/query',
            meta: {
              title: 'query'
            }
          },
          {
            path: 'personnel/export',
            meta: {
              title: 'export'
            }
          },
          {
            path: 'personnel/notice',
            meta: {
              title: 'notice'
            }
          },
          {
            path: 'personnel/customer',
            meta: {
              title: 'customer'
            }
          },
          {
            path: 'personnel/record',
            meta: {
              title: 'record'
            }
          },
        ]
      },{
        path: 'volunteer',
        component: () => import('@/views/service/volunteer'),
        name: 'volunteer',
        meta: {
          title: 'volunteers',
          icon: 'form',
          roles: ['admin', 'editor']
        },
        children: [
          {
            path: 'volunteer/delete',
            meta: {
              title: 'delete'
            }
          },
          {
            path: 'volunteer/edit',
            meta: {
              title: 'edit'
            }
          },{
            path: 'volunteer/record',
            meta: {
              title: 'record'
            }
          },
          {
            path: 'volunteer/query',
            meta: {
              title: 'query'
            }
          },
          {
            path: 'volunteer/export',
            meta: {
              title: 'export'
            }
          },
          {
            path: 'volunteer/notice',
            meta: {
              title: 'notice'
            }
          }

        ]
      },
      {
        path: 'customer',
        component: () => import('@/views/service/customer'),
        name: 'customer',
        meta: {
          title: 'service2',
          icon: 'form',
          roles: ['admin', ]
        },
        children: [{
            path: 'customer/delete',
            meta: {
              title: 'delete'
            }
          },
          {
            path: 'customer/query',
            meta: {
              title: 'query'
            }
          },
          {
            path: 'customer/export',
            meta: {
              title: 'customerExport'
            }
          },
          {
            path: 'customer/print',
            meta: {
              title: 'print'
            }
          },
          {
            path: 'customer/inport',
            meta: {
              title: 'customerInport'
            }
          },
          {
            path: 'customer/record',
            meta: {
              title: 'record'
            }
          },{
            path: 'customer/edit',
            meta: {
              title: 'edit'
            }
          },
          {
            path: 'customer/details',
            meta: {
              title: 'details'
            }
          },
          {
            path: 'customer/download',
            meta: {
              title: 'download'
            }
          },
          {
            path: 'customer/allocation',
            meta: {
              title: 'allocation'
            }
          },
        ]
      }, {
        path: 'customerLog',
        component: () => import('@/views/service/customerLog'),
        name: 'customerLog',
        meta: {
          title: 'customerLog',
          icon: 'form',
          roles: ['admin', ]
        },
        children: [
          {
            path: 'customerLog/query',
            meta: {
              title: 'query'
            }
          },
          {
            path: 'customerLog/details',
            meta: {
              title: 'handle'
            }
          },{
            path: 'customerLog/replayComment',
            meta: {
              title: 'replayComment'
            }
          },
          {
            path: 'customerLog/onlineLogDelete',
            meta: {
              title: 'onlineLogDelete'
            }
          },
          {
            path: 'customerLog/offlineLogDelete',
            meta: {
              title: 'offlineLogDelete'
            }
          },{
            path: 'customerLog/offlineLogComment',
            meta: {
              title: 'offlineLogComment'
            }
          },
          {
            path: 'customerLog/preCheckPass',
            meta: {
              title: 'preCheckPass'
            }
          },
          {
            path: 'customerLog/checkPass',
            meta: {
              title: 'checkPass'
            }
          },
          {
            path: 'customerLog/checkUnPass',
            meta: {
              title: 'checkUnPass'
            }
          },
          {
            path: 'customerLog/endCheckUnPass',
            meta: {
              title: 'endCheckUnPass'
            }
          }
        ]
      },
      {
        path: 'record',
        component: () => import('@/views/service/record'),
        name: 'record',
        meta: {
          title: 'service3',
          icon: 'form',
          roles: ['admin', ]
        },
        children: [{
            path: 'record/delete',
            meta: {
              title: 'delete'
            }
          },
          {
            path: 'record/query',
            meta: {
              title: 'query'
            }
          },
          {
            path: 'record/export',
            meta: {
              title: 'export'
            }
          },
          {
            path: 'record/details',
            meta: {
              title: 'details'
            }
          },
          {
            path: 'record/reset',
            meta: {
              title: 'reset'
            }
          },
          {
            path: 'record/replayComment',
            meta: {
              title: 'replayComment'
            }
          },
          {
            path: 'record/callLogDelete',
            meta: {
              title: 'callLogDelete'
            }
          },
          {
            path: 'record/callLogExport',
            meta: {
              title: 'callLogExport'
            }
          },
          {
            path: 'record/preCheckPass',
            meta: {
              title: 'preCheckPass'
            }
          },
          {
            path: 'record/checkPass',
            meta: {
              title: 'checkPass'
            }
          },
          {
            path: 'record/checkUnPass',
            meta: {
              title: 'checkUnPass'
            }
          },
          {
            path: 'record/endCheckUnPass',
            meta: {
              title: 'endCheckUnPass'
            }
          }
        ]
      },
      {
        path: 'category',
        component: () => import('@/views/service/category'),
        name: 'category',
        meta: {
          title: 'service4',
          icon: 'form',
          roles: ['admin', 'editor']
        },
        children: [{
            path: 'category/delete',
            meta: {
              title: 'delete'
            }
          },
          {
            path: 'category/query',
            meta: {
              title: 'query'
            }
          },
          {
            path: 'category/increase',
            meta: {
              title: 'increase'
            }
          },
          {
            path: 'category/edit',
            meta: {
              title: 'edit'
            }
          },
          {
            path: 'category/project',
            meta: {
              title: 'project'
            }
          },{
            path: 'category/projectQuery',
            meta: {
              title: 'projectQuery'
            }
          },{
            path: 'category/projectIncrease',
            meta: {
              title: 'projectIncrease'
            }
          },{
            path: 'category/projectEdit',
            meta: {
              title: 'projectEdit'
            }
          },{
            path: 'category/projectDelete',
            meta: {
              title: 'projectDelete'
            }
          },
        ]
      },
      // {
      //   path: 'callRecords',
      //   component: () => import('@/views/guide/callRecords'),
      //   name: 'callRecords',
      //   meta: {
      //     title: 'callRecords',
      //     icon: 'form',
      //     breadcrumb: false,
      //     roles: ['admin']
      //   },
      //   children: [{
      //       path: 'callRecords/delete',
      //       meta: {
      //         title: 'delete'
      //       }
      //     },
      //     {
      //       path: 'callRecords/export',
      //       meta: {
      //         title: 'export'
      //       }
      //     },
      //   ]
      // }
    ]
  },
  {
    path: '/recycle', //回收站
    component: Layout,
    redirect: 'noRedirect',
    name: 'recycle',
    alwaysShow: true,
    meta: {
      title: 'recycle',
      icon: 'tab',
    },
    children: [{
      path: 'restore',
      component: () => import('@/views/recycle/index'),
      name: 'recycle1',
      meta: {
        title: 'recycle',
        icon: 'tab',
        roles: ['admin']
      },
      children: [{
          path: 'recycle/delete',
          meta: {
            title: 'delete'
          }
        },
        {
          path: 'recycle/query',
          meta: {
            title: 'query'
          }
        },
        {
          path: 'recycle/reback',
          meta: {
            title: 'reduction'
          }
        },
      ]
    }]
  },
  {
    path: '/operate', //运营管理
    component: Layout,
    redirect: 'noRedirect',
    name: 'operate',
    alwaysShow: true,
    meta: {
      title: 'operate',
      icon: 'tab',
    },
    children: [{
      path: '/activity',
      component: () => import('@/views/operate/activity/index'),
      name: 'activity',
      meta: {
        title: 'activity',
        icon: 'tab',
        roles: ['admin']
      },
      children: [
        {
          path: 'activity/query',
          meta: {
            title: 'query'
          }
        },
        {
          path: 'activity/increase',
          meta: {
            title: 'increase'
          }
        },
        {
          path: 'activity/edit',
          meta: {
            title: 'edit'
          }
        },
        {
          path: 'activity/delete',
          meta: {
            title: 'delete'
          }
        },{
          path: 'activity/editEnroll',
          meta: {
            title: 'editEnroll'
          }
        },{
          path: 'activity/exportEnroll',
          meta: {
            title: 'exportEnroll'
          }
        },
      ]
    },{
      path: '/notice',
      component: () => import('@/views/operate/notice/index'),
      name: 'notice',
      meta: {
        title: 'notice',
        icon: 'tab',
        roles: ['admin']
      },
      children: [
        {
          path: 'notice/query',
          meta: {
            title: 'query'
          }
        },
        {
          path: 'notice/increase',
          meta: {
            title: 'increase'
          }
        },
        {
          path: 'notice/edit',
          meta: {
            title: 'edit'
          }
        },
        {
          path: 'notice/delete',
          meta: {
            title: 'delete'
          }
        },
      ]
    },{
      path: '/news',
      component: () => import('@/views/operate/news/index'),
      name: 'news',
      meta: {
        title: 'news',
        icon: 'tab',
        roles: ['admin']
      },
      children: [
        {
          path: 'news/query',
          meta: {
            title: 'query'
          }
        },
        {
          path: 'news/increase',
          meta: {
            title: 'increase'
          }
        },
        {
          path: 'news/edit',
          meta: {
            title: 'edit'
          }
        },
        {
          path: 'news/delete',
          meta: {
            title: 'delete'
          }
        },
      ]
    },
    {
      path: '/recruit',
      component: () => import('@/views/operate/recruit/index'),
      name: 'recruit',
      meta: {
        title: 'recruit',
        icon: 'tab',
        roles: ['admin']
      },
      children: [
        {
          path: 'recruit/query',
          meta: {
            title: 'query'
          }
        },
        {
          path: 'recruit/increase',
          meta: {
            title: 'increase'
          }
        },
        {
          path: 'recruit/edit',
          meta: {
            title: 'edit'
          }
        },
        {
          path: 'recruit/delete',
          meta: {
            title: 'delete'
          }
        },{
          path: 'recruit/editDelivery',
          meta: {
            title: 'editDelivery'
          }
        },{
          path: 'recruit/exportDelivery',
          meta: {
            title: 'exportDelivery'
          }
        },
      ]
    },
    ]
  },{
    path: '/company', //运营管理
    component: Layout,
    redirect: 'noRedirect',
    name: 'company',
    alwaysShow: true,
    meta: {
      title: 'company',
      icon: 'tab',
    },
    children: [{
      path: '/auth',
      component: () => import('@/views/company/auth/index'),
      name: 'auth',
      meta: {
        title: 'auth',
        icon: 'auth',
        roles: ['admin']
      },
      children: [
        {
          path: 'auth/query',
          meta: {
            title: 'query'
          }
        },
        {
          path: 'auth/verify',
          meta: {
            title: 'verify'
          }
        },{
          path: 'auth/detail',
          meta: {
            title: 'details'
          }
        }
      ]
    }]
  },
  {
    path: '*',
    redirect: '/404',
    hidden: true
  }
]
